import { HCP_SEGMENTATION_CUBE_NAME } from '@/api/hcp';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { Filter } from '@cubejs-client/core';

const ROCHE_INTERACTION_LADDER_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.roche_interaction`],
  limit: 10,
});

const rocheInteractionLadderFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.rocheInteractionLadderLabel',
  sourceCube: HCP_SEGMENTATION_CUBE_NAME,
  defaultValue: [],
  type: 'multiselect',
  placeholder: 'global.filters.formControls.rocheInteractionLadderPlaceholder',
  searchable: true,
  clearable: true,
  getOptionsQuery: ROCHE_INTERACTION_LADDER_OPTIONS,
  mapResult: mapDimensionToOption(`${HCP_SEGMENTATION_CUBE_NAME}.roche_interaction`),
  applyFilter: (value): Filter | undefined => {
    if (Array.isArray(value) && value.every(v => typeof v === 'string')) {
      return {
        member: `${HCP_SEGMENTATION_CUBE_NAME}.roche_interaction`,
        operator: 'equals',
        values: value,
      };
    }
  },
};

export default rocheInteractionLadderFilter;
